import { TReceiptEntity } from "@elixir/types";
import dayjs from "dayjs";
import {
  formatReceiptDataForExcel,
  multipleReceiptsToSeperateRowForQueue,
} from "@elixir/utils";

export const summaryReportDownloadTimelineOptions = [
  { label: "Last 7 days", name: "last-7-days" },
  { label: "Custom Date", name: "custom" },
];

export const detailedReportDownloadTimelineOptions = [
  { label: "Today", name: "today" },
  { label: "Last 7 days", name: "last-7-days" },
  { label: "Custom Date", name: "custom" },
];

export const getTimelineDates = ({
  timelineDuration,
  customDates,
}: {
  timelineDuration?: string;
  customDates?: string[];
}): { startDate?: string; endDate?: string } => {
  if (timelineDuration === "custom-date" && customDates) {
    const [startDate, endDate] = customDates;
    return {
      startDate: dayjs(startDate).format("YYYY-MM-DD"),
      endDate: dayjs(endDate).format("YYYY-MM-DD"),
    };
  } else if (timelineDuration === "today") {
    const currentDate = dayjs().format("YYYY-MM-DD");
    return { startDate: currentDate, endDate: currentDate };
  } else if (timelineDuration === "last-7-days") {
    const currentDate = dayjs().format("YYYY-MM-DD");
    const lastWeekDate = dayjs().subtract(6, "days").format("YYYY-MM-DD");
    return { startDate: lastWeekDate, endDate: currentDate };
  }
  return {};
};

export const formatMutltipleReceiptToSeperateRow =
  multipleReceiptsToSeperateRowForQueue;

export function formatTransactionData(
  receiptItem: TReceiptEntity,
  index: number
) {
  return formatReceiptDataForExcel({ receiptItem, index });
}
